import { IApplicationState } from '../../types/redux';
import { selectOffer } from './selectOffer';

export const selectOfferGaLabel = (id: number) => (state: IApplicationState) => {
  const offer = selectOffer(id)(state);

  return offer.analytics?.gaLabel || '';
};
